export const validatePassword = (value: string) => {
  const regExp = /^(?=.*[A-Z])(?=.*\S)[a-zA-Z\d!@#$%^&*()_+`~\-={}[\]\\|:;"'<>,.?/]{8,}$/;
  return regExp.test(value);
};

export const validateEmail = (email: string) => {
  const regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return regExp.test(email);
};

export const validateUserName = (userName: string) => {
  const regExp = /^[a-zA-Z0-9_.-]{4,20}$/;
  return regExp.test(userName);
};

export const validateName = (name: string) => {
  const regExp = /^\s*[\S]+.*$/;
  return regExp.test(name);
};

export const validateStandartCharacters = (val: string) => {
  const regExp = /^(?:[A-Za-z]+\s*)+$/;
  return regExp.test(val);
};

export const validateIpAndDns = (value: string) => {
  const regex = /^(?!:\/\/)(?!.*:\/\/\/\/)(?!.*?\.\.)((?:[a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*(?:[A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
  return regex.test(value);
};

export const validateAllWhiteSpaces = (val: string) => val && !val.trim();
